module.exports = __webpack_public_path__ + "img/DataExplorer.9650854e.svg";